<ng-container *transloco="let t">
  <h2 mat-dialog-title>{{ t('tenants.trocarEmpresa') }}</h2>

  <mat-dialog-content>
    <mat-form-field class="w-full" subscriptSizing="dynamic">
      <mat-icon matPrefix [svgIcon]="'heroicons_outline:magnifying-glass'"></mat-icon>
      <input
        matInput
        [(ngModel)]="searchText"
        (ngModelChange)="onSearch()"
        [placeholder]="t('tenants.buscarEmpresa')"
        autocomplete="off"
      />
    </mat-form-field>

    <div class="mt-4 max-h-[32rem] overflow-y-auto">
      <div *ngIf="loading" class="flex justify-center py-6">
        <mat-spinner diameter="28"></mat-spinner>
      </div>

      <ng-container *ngIf="!loading">
        <button
          *ngFor="let tenant of tenants"
          mat-button
          class="w-full flex items-center justify-start px-2 py-1"
          [disabled]="tenant.current"
          (click)="select(tenant)"
        >
          <mat-icon
            class="icon-size-4 mr-2"
            [svgIcon]="tenant.current ? 'heroicons_solid:check-circle' : 'heroicons_outline:building-office'"
          ></mat-icon>
          <span class="truncate">{{ tenant.name }} - {{ tenant.document }}</span>
        </button>

        <p *ngIf="!tenants.length" class="text-secondary text-center py-6">
          {{ t('tenants.nenhumaEmpresaEncontrada') }}
        </p>

        <div *ngIf="loadingMore" class="flex justify-center py-3">
          <mat-spinner diameter="20"></mat-spinner>
        </div>

        <button
          *ngIf="canLoadMore"
          mat-button
          class="w-full"
          (click)="loadMore()"
        >
          {{ t('tenants.carregarMais') }}
        </button>
      </ng-container>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button type="button" mat-dialog-close>{{ t('crud.cancel') }}</button>
  </mat-dialog-actions>
</ng-container>
